import React from 'react';
import { Spinner } from '../../components/ui';
import { INVITE_STATUSES, inviteChipClass, sideChipClass, fullName } from '../../utils/helpers';

// Desktop UI for Mark Status — the four status boards side by side when the
// screen has room (two per line on a laptop), each a compact table with the
// quick-move buttons at the end of the row.
export default function StatusDesktop({ vm }) {
  const { isAdmin, canEdit, mine, rows, loading, grouped, mark } = vm;
  return (
    <div>
      <div className="page-head">
        <h1>Mark Status</h1>
        <span className="muted">
          {rows.length} · {INVITE_STATUSES.map(s => `${grouped[s].length} ${s.toLowerCase()}`).join(' · ')}
        </span>
      </div>
      <div className="muted" style={{ marginBottom: 10, fontSize: 13 }}>
        {isAdmin ? 'All members across the event.' : 'The members you added.'} Use the buttons to mark each as Invited, Confirmed or Declined.
      </div>

      {loading ? <Spinner /> : rows.length === 0 ? (
        <div className="card card-pad empty">No members yet.</div>
      ) : (
        <div className="gx-status-grid">
          {INVITE_STATUSES.map(status => (
            <div key={status} className="card gx-status-card">
              <h3>
                <span className={inviteChipClass(status)}>{status}</span>
                <span className="muted" style={{ fontSize: 13, fontWeight: 400 }}>{grouped[status].length}</span>
              </h3>
              {grouped[status].length === 0 ? <div className="muted" style={{ fontSize: 13 }}>None.</div> : (
                <div className="table-wrap">
                  <table className="tbl compact">
                    <tbody>
                      {grouped[status].map(row => (
                        <tr key={row.GuestId}>
                          <td>{fullName(row)}</td>
                          <td className="gx-mob">{row.MobileNumber || '—'}</td>
                          <td className="gx-fn" title={row.FunctionName || undefined}>{row.FunctionName || '—'}</td>
                          <td><span className={sideChipClass(row.Side)}>{row.Side}</span></td>
                          {isAdmin && <td>{(row.AddedByName || row.InvitedByName || '').trim() || '—'}</td>}
                          {canEdit && (
                            <td className="gx-move">
                              {mine(row)
                                ? INVITE_STATUSES.filter(s => s !== status).map(s => (
                                    <button key={s} className="btn light sm" onClick={() => mark(row, s)}>{s}</button>
                                  ))
                                : <span className="muted" style={{ fontSize: 12 }}>shared</span>}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
